export default __webpack_public_path__ + "static/media/notification.0f1427f8.svg";